import React from 'react';
import PropTypes from 'prop-types';
import ReactImageUploadComponent from 'react-images-upload';

function ImageUploader({ imgExtension, maxFileSize, ...rest }) {
  const getFileSizeText = () => {
    if (maxFileSize > 1000000) {
      return `${(maxFileSize / 1000000).toFixed(1)} MB`;
    }
    return `${maxFileSize} kB`;
  };

  const getFileExtensionsText = () =>
    imgExtension.map(ext => ext.substring(1)).join('|');

  const label = `Max file size: ${getFileSizeText()}, accepted: ${getFileExtensionsText()}`;

  return (
    <ReactImageUploadComponent
      buttonText="Select Image"
      imgExtension={imgExtension}
      maxFileSize={10000000}
      label={label}
      singleImage
      {...rest}
    />
  );
}

ImageUploader.propTypes = {
  imgExtension: PropTypes.arrayOf(PropTypes.string),
  maxFileSize: PropTypes.number,
};

ImageUploader.defaultProps = {
  imgExtension: ['.jpg', '.jpeg', '.png', '.gif'],
  maxFileSize: 10000000,
};

export default ImageUploader;
